import React from 'react';
import Modal from './Modal';
import { TILE_CHARACTERS } from '@/utils/constants';

const GalleryModal = ({ isOpen, onClose, unlockedTiles }) => {
  const allTiles = [2, 4, 8, 16, 32, 64, 128, 256, 512, 1024, 2048];
  const unlockedCount = Object.keys(unlockedTiles).length;
  const progress = (unlockedCount / allTiles.length) * 100;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="卡通角色圖鑑">
      {/* 收集進度 */}
      <div className="text-center mb-4">
        <div className="text-lg font-black text-gray-700 mb-2">
          收集進度：{unlockedCount} / {allTiles.length}
        </div>
        <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden shadow-inner">
          <div 
            className="bg-gradient-to-r from-yellow-400 via-orange-400 to-pink-400 h-3 rounded-full transition-all duration-500 relative"
            style={{ width: `${progress}%` }}
          >
            <div className="absolute inset-0 bg-white/30 animate-pulse"></div>
          </div>
        </div>
        <p className="text-xs text-gray-500 mt-1 font-bold">
          {progress === 100 ? '🎉 全部收集完成！' : `還差 ${allTiles.length - unlockedCount} 個角色`}
        </p>
      </div>

      {/* 圖鑑網格 */}
      <div className="grid grid-cols-4 gap-3">
        {allTiles.map((val) => {
          const isUnlocked = unlockedTiles[val];
          return (
            <div
              key={val}
              className={`bg-white/80 p-3 rounded-2xl text-center flex flex-col items-center transition-all duration-300 border-2 ${
                isUnlocked 
                  ? 'border-yellow-300 shadow-lg scale-105' 
                  : 'border-gray-200 shadow-sm'
              }`}
            >
              {/* 角色顯示 - 修改此處：未解鎖時只用 grayscale，提高不透明度至 90% 使其清晰可見 */}
              <div className={`text-4xl mb-2 transition-all duration-300 ${
                isUnlocked 
                  ? 'filter-none' 
                  : 'grayscale opacity-90'
              }`}>
                {TILE_CHARACTERS[val]}
              </div>

              {/* 數值 */}
              <div className={`text-xs font-black mb-1 ${
                isUnlocked ? 'text-gray-700' : 'text-gray-400'
              }`}>
                {val}
              </div>

              {/* 解鎖狀態 */}
              {isUnlocked ? (
                <div className="text-[10px] font-bold text-green-500 bg-green-50 px-2 py-0.5 rounded-full">
                  ✓ 已解鎖
                </div>
              ) : (
                <div className="text-[9px] font-bold text-gray-400 bg-gray-100 px-2 py-0.5 rounded-full">
                  🔒 未解鎖
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* 提示文字 */}
      <div className="mt-6 text-center bg-blue-50 p-3 rounded-2xl border-2 border-blue-100">
        <p className="text-xs text-blue-600 font-bold">
          💡 提示：持續合成方塊即可解鎖更多可愛角色！
        </p>
      </div>
    </Modal>
  );
};

export default GalleryModal;